import { useEffect, useState } from 'react';

const useDebounce = (cb: string, delay: number): string => {
  const [debounceValue, setDebounceValue] = useState(cb);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebounceValue(cb);
    }, delay);

    return (): void => {
      clearTimeout(handler);
    };
  }, [cb, delay]);
  return debounceValue;
};

export default useDebounce;
